/**
 * v3.15-1162 — Mission (manifesto, not prose).
 */
import PublicLayout from '../components/PublicLayout';
import EndPageCTA from '../components/EndPageCTA';
import { HubCommunicationsScreenshot } from '../components/HubProductImagery';

const MissionPage = () => (
  <PublicLayout testId="mission-page">

    {/* HERO — full-bleed manifesto */}
    <section className="bg-primary text-white px-6 py-32 lg:py-44">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-10">Our Mission</p>
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight">
          Personalized guidance.<br />
          Complete transparency.<br />
          <span className="text-gradient-gold">Better outcomes.</span>
        </h1>
      </div>
    </section>

    {/* Three convictions */}
    <section className="bg-white px-6 py-28 lg:py-36">
      <div className="max-w-5xl mx-auto space-y-20">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Conviction One</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-[1.1] max-w-3xl">
            Every client deserves personalized guidance — not another application number.
          </h2>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Conviction Two</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-[1.1] max-w-3xl">
            Every partner deserves complete transparency — not unanswered questions.
          </h2>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Conviction Three</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-[1.1] max-w-3xl">
            Every opportunity deserves to be fully explored — not closed at the first &ldquo;no.&rdquo;
          </h2>
        </div>
      </div>
    </section>

    {/* What it looks like in the Hub — proof for the mission */}
    <section className="bg-slate-50 px-6 py-28 lg:py-36">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">How the mission shows up</p>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold text-primary leading-[1.1] mb-6">
            Personalized guidance, in practice.
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed max-w-xl">
            Every client gets one Concierge they can reach by name. Every partner sees the same conversation, the same notes, the same status — in real time, inside the Hub.
          </p>
        </div>
        <HubCommunicationsScreenshot />
      </div>
    </section>

    {/* Closing manifesto */}
    <section className="bg-gradient-to-b from-slate-900 to-primary text-white px-6 py-32 lg:py-44">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-8">What we&rsquo;re building</p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] mb-10">
          Our goal is not simply<br />to fund loans.
        </h2>
        <p className="font-heading text-2xl sm:text-3xl text-gradient-gold font-medium leading-tight max-w-3xl mx-auto">
          Our goal is to create successful financial outcomes that strengthen our partners, serve our clients, and build lasting relationships.
        </p>
      </div>
    </section>

    <EndPageCTA testId="mission-end-cta" />
  </PublicLayout>
);

export default MissionPage;
